import React from 'react';
import { Dashboard } from '@components';
import { HeadContent } from '@fourthwall/components';
import { GiveawayPackagesData } from './components/GiveawayPackagesData/GiveawayPackagesData';
import { useGiveawayPackagesQuery } from './queries/useGiveawayPackagesQuery';
export const GiveawayPackages = () => {
    const { giveawayPackagesQuery } = useGiveawayPackagesQuery(undefined, {
        keepPreviousData: true,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Giveaway links" }),
        React.createElement(Dashboard.Section.Item, null,
            React.createElement(GiveawayPackagesData, { data: giveawayPackagesQuery.data?.packages || [], isLoading: giveawayPackagesQuery.isLoading }))));
};
